import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Popper,
} from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  LIVE_MAP_UI_RIDE_FILTERS,
  liveMapRideFilterTranslationKey,
  useIsMobile,
} from "@ryde/shared";

import { LiveMapRideFilterDropdownMenuStyled } from "../live-map-ride-filter.dropdown.styled";
import { LiveMapRideFilterPreview } from "./live-map-ride-filter.preview";
import { TUseLiveMapRideFilterDropdown } from "./use-live-map-ride-filter-dropdown";

interface ILiveMapRideFilterDropdownArea {
  hookData: TUseLiveMapRideFilterDropdown;
}

const POPOVER_Y_OFFSET = 4;

export const LiveMapRideFilterDropdownArea: FC<
  ILiveMapRideFilterDropdownArea
> = ({ hookData }) => {
  const { t } = useTranslation();
  const { isMobile } = useIsMobile();
  const {
    anchorRef,
    closePopover,
    effectiveRideFilter,
    handleItemClick,
    isPopoverOpen,
  } = hookData;

  return (
    <Popper
      open={isPopoverOpen}
      anchorEl={anchorRef.current}
      transition
      disablePortal={!isMobile}
      placement="bottom-start"
      className="live-map-ride-filter-popper"
      popperOptions={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, POPOVER_Y_OFFSET],
            },
          },
        ],
      }}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps}>
          <LiveMapRideFilterDropdownMenuStyled elevation={8}>
            <ClickAwayListener onClickAway={closePopover}>
              <MenuList
                data-e2e="live-map-ride-filter-dropdown-list"
                autoFocusItem
              >
                {LIVE_MAP_UI_RIDE_FILTERS.map(filter => (
                  <MenuItem
                    key={filter}
                    selected={effectiveRideFilter === filter}
                    className="live-map-ride-filter-dropdown-item"
                    onMouseDown={event => event.preventDefault()}
                    onClick={event => handleItemClick(event, filter)}
                  >
                    <LiveMapRideFilterPreview filter={filter} />
                    <span className="live-map-ride-filter-dropdown-item__label">
                      {t(liveMapRideFilterTranslationKey(filter))}
                    </span>
                  </MenuItem>
                ))}
              </MenuList>
            </ClickAwayListener>
          </LiveMapRideFilterDropdownMenuStyled>
        </Grow>
      )}
    </Popper>
  );
};
